module.exports = __webpack_public_path__ + "static/media/chat.2e892bc3.png";